import { z } from 'zod';

export const searchSchema = z.object({
  companyIds: z.array(z.number()),
  salary: z.string().optional(),
  minSalary: z.string().optional(),
  maxSalary: z.string().optional(),
  jobPositions: z.string().default(''),
  // 都道府県コード絞り込み（Issue #3401）
  prefectureCodes: z.array(z.number()),
  customTagIds: z.array(z.number()),
  customTagMatch: z.enum(['all', 'any']).optional(),
  listId: z.string().optional(),
  searchColumnAlpha: z.string(),
  searchKeywordAlpha: z.string().optional(),
  searchOperatorAlpha: z.string(),
  searchColumnBeta: z.string(),
  searchKeywordBeta: z.string().optional(),
  searchOperatorBeta: z.string(),
  searchColumnGamma: z.string(),
  searchKeywordGamma: z.string().optional(),
  searchOperatorGamma: z.string(),
  isIncludeArchived: z.boolean(),
  isSalaryEmpty: z.boolean(),
  sort: z.string(),
  jobSourceId: z.number().optional(),
  createdType: z.string().optional(),
});

export type FormValue = z.infer<typeof searchSchema>;
// useForm の入力型（`.default()` を持つフィールドは入力時 optional になる）。
// zodResolver v5 は入力/出力型を分離するため、useForm<SearchFormInput, ctx, FormValue> で使う。
export type SearchFormInput = z.input<typeof searchSchema>;
